module.exports = __webpack_public_path__ + "static/media/logo.28b68701.png";